// Mock data for Anjaneya Inks and Coating website
// Facility photos: all 9 are the client's real photographs (hosted on customer-assets).

const u = (id, w = 1200) =>
  `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&q=80&w=${w}`;

export const company = {
  name: "Anjaneya Inks and Coating",
  shortName: "Anjaneya Inks",
  tagline: "Colors That Speak, Coatings That Last.",
  address:
    "12-57, Survey No-851/P, Medchal Village, Medchal Mandal, Malkajgiri, Telangana - 501401",
  addressLines: [
    "12-57, Survey No-851/P,",
    "Medchal Village, Medchal Mandal,",
    "Malkajgiri, Telangana - 501401",
  ],
  phone: "9490853292",
  phoneDisplay: "+91 94908 53292",
  phone2: "9966963292",
  phone2Display: "+91 99669 63292",
  whatsapp: "919966963292",
  whatsappDisplay: "+91 99669 63292",
  // Where form enquiries are forwarded on WhatsApp
  enquiryWhatsapp: "919966963292",
  enquiryWhatsappDisplay: "+91 99669 63292",
  enquiryEmail: "getaswinisahoo@gmail.com",
  gst: "36GAWPS4819F1ZX",
  email: "anjaneyainks@gmail.com",
  hours: "Mon - Sat: 9:00 AM - 6:30 PM",
  mapsUrl:
    "https://www.google.com/maps/search/?api=1&query=Medchal+Village+Medchal+Mandal+Telangana+501401",
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "About Us", path: "/about" },
  { label: "Production", path: "/production" },
  { label: "Gallery", path: "/gallery" },
  { label: "Contact", path: "/contact" },
];

// Facility photos (placeholders - map 1:1 to the client's file names)
export const facilityPhotos = {
  mainGate: { file: "Main Gate.jpeg", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_anjaneya-inks/artifacts/h9bdupgc_Main%20Gate.jpeg", alt: "Anjaneya Inks and Coating - Main Gate, Medchal" },
  companyFront: { file: "Company Front.jpeg", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_anjaneya-inks/artifacts/2ql2po1k_Company%20Front.jpeg", alt: "Anjaneya Inks and Coating - Company Front" },
  companySide: { file: "Company Side.jpeg", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_anjaneya-inks/artifacts/o94bzpln_Company%20Side.jpeg", alt: "Anjaneya Inks and Coating - Company Side View" },
  productionHouse: { file: "Production house.jpeg", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_anjaneya-inks/artifacts/2qrzb8jw_Production%20house.jpeg", alt: "Production House - Mixing, Milling & Dispersion" },
  productionHouse1: { file: "Production house1.jpeg", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_anjaneya-inks/artifacts/pahr1pw0_Production%20house1.jpeg", alt: "Production House - High-speed Dispersers" },
  productionHouse2: { file: "Production house2.jpeg", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_anjaneya-inks/artifacts/hy21mtjk_Production%20house2.jpeg", alt: "Production House - Filling & Let-down Line" },
  deliveryUnit: { file: "Delivery Unit.jpeg", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_anjaneya-inks/artifacts/u4tb4etc_Delivery%20Unit.jpeg", alt: "Anjaneya Inks branded drum - Packed & Ready for Delivery" },
  stock1: { file: "Stock1.jpeg", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_anjaneya-inks/artifacts/8ntecato_Stock1.jpeg", alt: "Stock Yard - Drums & Raw Material Inventory" },
  stock2: { file: "Stock2.jpeg", src: "https://customer-assets-gfyr7b9c.emergentagent.net/job_anjaneya-inks/artifacts/nbixwdnr_Stock2.jpeg", alt: "Ready Stock - Packed Ink Cans in Multiple Shades" },
};

export const heroSlides = [
  {
    id: 1,
    image: facilityPhotos.mainGate.src,
    eyebrow: "Welcome to",
    title: "Anjaneya Inks and Coating",
    subtitle: company.tagline,
    text: "Manufacturers of premium printing inks and industrial coatings, crafted with precision at our Medchal facility.",
    cta: { label: "Reach Us", path: "/contact" },
  },
  {
    id: 2,
    image: facilityPhotos.companyFront.src,
    eyebrow: "Our Facility",
    title: "Built for Quality, Scaled for Volume",
    subtitle: "Modern production house in Medchal, Telangana",
    text: "From pigment dispersion to final packing, every batch is engineered for consistency and long-lasting performance.",
    cta: { label: "Explore Production", path: "/production" },
  },
  {
    id: 3,
    image: facilityPhotos.companySide.src,
    eyebrow: "Always Ready",
    title: "Bulk & Emergency Orders Welcome",
    subtitle: "Ready stock. Rapid dispatch.",
    text: "Our stocked warehouse and dedicated delivery unit ensure your production line never waits for ink.",
    cta: { label: "Request a Quote", path: "/contact#quote" },
  },
];

export const products = [
  {
    id: "offset-inks",
    title: "Offset Inks",
    image: u("photo-1503694978374-8a2fa686963a", 900),
    description:
      "Premium sheetfed and web offset inks with excellent gloss, fast setting and superior dot sharpness. Ideal for cartons, books, magazines, calendars and marketing collateral where vibrant, consistent colour matters.",
  },
  {
    id: "flexo-gravure-inks",
    title: "Flexo & Gravure Inks",
    image: u("photo-1693031630369-bd429a57f115", 900),
    description:
      "Solvent-based and water-based inks engineered for flexible packaging, labels and laminates. Strong adhesion, high-speed printability and heat resistance for polyolefin, PET, BOPP and paper substrates.",
  },
  {
    id: "industrial-coatings",
    title: "Industrial Coatings",
    image: u("photo-1535673774336-ef95d2851cf3", 900),
    description:
      "Protective and decorative coatings for metal, wood and engineered surfaces. Formulated for corrosion resistance, weather durability and a finish that lasts through demanding service conditions.",
  },
  {
    id: "packaging-coatings",
    title: "Packaging Coatings & Varnishes",
    image: u("photo-1708746333890-8e775f97f0a6", 900),
    description:
      "Overprint varnishes, barrier coatings and heat-seal lacquers that protect printed packaging, enhance shelf appeal and comply with food-contact requirements.",
  },
  {
    id: "custom-colour",
    title: "Custom Colour Matching",
    image: facilityPhotos.stock2.src,
    description:
      "Pantone and brand-specific shade matching by our in-house colour lab. We deliver repeatable colour across runs, substrates and print processes with full batch traceability.",
  },
  {
    id: "bulk-supply",
    title: "Bulk & Emergency Supply",
    image: facilityPhotos.stock1.src,
    description:
      "Ready inventory of standard shades and bases with a dedicated dispatch unit. We accept bulk orders and urgent emergency requirements with rapid turnaround across Telangana and beyond.",
  },
];

export const applications = [
  { id: 1, title: "Board Packaging", image: u("photo-1700165644892-3dd6b67b25bc", 700) },
  { id: 2, title: "Flexible Packaging", image: u("photo-1708746333890-8e775f97f0a6", 700) },
  { id: 3, title: "Blister Packaging", image: u("photo-1584308666744-24d5c474f2ae", 700) },
  { id: 4, title: "News Print", image: u("photo-1498644035638-2c3357894b10", 700) },
  { id: 5, title: "Self-Adhesive Labels", image: u("photo-1773525912464-d2640e7aff9c", 700) },
  { id: 6, title: "Metal Decoration", image: u("photo-1674176508097-463b009c6004", 700) },
  { id: 7, title: "Magazines & Brochures", image: "https://images.pexels.com/photos/1007027/pexels-photo-1007027.jpeg?auto=compress&cs=tinysrgb&w=700" },
  { id: 8, title: "Industrial Surfaces", image: facilityPhotos.productionHouse1.src },
];

export const industries = [
  { id: 1, icon: "BookOpen", title: "Book Printing", text: "Clear text, distinctive images and high clarity for books, leaflets and catalogues across offset processes." },
  { id: 2, icon: "Newspaper", title: "Newspaper", text: "High-mileage news inks for slow and high-speed presses with consistent density and quick drying." },
  { id: 3, icon: "Pill", title: "Pharma", text: "Inks and coatings for blister packs, foils, sachets and labels meeting stringent pharma print standards." },
  { id: 4, icon: "UtensilsCrossed", title: "Food & Beverage", text: "Low-odour, low-migration solutions for mono cartons, flexible packs, wraps and re-sealable pouches." },
  { id: 5, icon: "Sparkles", title: "Personal Care", text: "Vivid shades and premium finishes for cartons, shrink sleeves and labels that stand out on shelf." },
  { id: 6, icon: "Package", title: "Consumer Goods", text: "Durable inks for corrugated and laminated boxes protecting appliances and household products." },
  { id: 7, icon: "Factory", title: "Engineering", text: "Protective industrial coatings for machinery, structures and fabricated metal components." },
  { id: 8, icon: "Megaphone", title: "Marketing & POP", text: "Danglers, posters, tent cards and brochures printed with brilliant, faithful brand colours." },
];

export const stats = [
  { value: "500+", label: "Shades Formulated" },
  { value: "24 hr", label: "Emergency Dispatch" },
  { value: "100%", label: "Batch Traceability" },
  { value: "1000s", label: "Litres Ready Stock" },
];

export const values = [
  { icon: "Palette", title: "Colour Precision", text: "Shade matching by experienced colourists using calibrated spectrophotometers." },
  { icon: "ShieldCheck", title: "Lasting Quality", text: "Every batch tested for viscosity, tack, gloss and adhesion before release." },
  { icon: "Truck", title: "Reliable Delivery", text: "Dedicated delivery unit with packed, labelled stock ready to ship." },
  { icon: "Leaf", title: "Responsible Chemistry", text: "Low-VOC and water-based options that reduce environmental impact." },
];

export const productionSteps = [
  { step: "01", title: "Raw Material Inspection", text: "Pigments, resins and solvents are verified against specifications before entering production." },
  { step: "02", title: "Pre-mixing & Dispersion", text: "High-speed dispersers wet out pigment into the vehicle for a uniform pre-mix." },
  { step: "03", title: "Milling & Grinding", text: "Bead mills and three-roll mills achieve the fine particle size that delivers gloss and strength." },
  { step: "04", title: "Let-down & Colour Matching", text: "Batch is adjusted to target shade, viscosity and tack in our colour laboratory." },
  { step: "05", title: "Quality Control", text: "Draw-downs, proof prints and lab tests certify every batch against the standard." },
  { step: "06", title: "Filling & Packing", text: "Filled into 1kg to 200kg packs, sealed, labelled and staged for dispatch." },
];

export const productionHighlights = [
  {
    id: "production",
    badge: "Production House",
    title: "Where Colour Comes to Life",
    text: "Our production house in Medchal houses dispersers, bead mills and three-roll mills operated by an experienced team. Controlled processes and clean-room practices ensure every kilo of ink and coating meets the same exacting standard.",
    images: [facilityPhotos.productionHouse, facilityPhotos.productionHouse1, facilityPhotos.productionHouse2],
  },
  {
    id: "delivery",
    badge: "Delivery Unit",
    title: "Packed, Labelled & Ready for Delivery",
    text: "Finished goods are filled into Anjaneya-branded drums and packs, sealed and labelled with date, colour, batch number and gross, tare and net weights - then staged in our delivery unit so your stores team receives exactly what was ordered, on time.",
    images: [facilityPhotos.deliveryUnit],
  },
  {
    id: "stock",
    badge: "Ready Stock",
    title: "Ready to Accept Bulk & Emergency Orders",
    text: "We maintain a healthy inventory of standard shades, bases and varnishes at all times. Whether you need a truckload for a new campaign or an urgent top-up at short notice, our stock yard and dispatch team are ready.",
    images: [facilityPhotos.stock1, facilityPhotos.stock2],
  },
];

export const team = [
  { name: "Founder & Managing Director", role: "Leadership", text: "Sets the vision of colour precision and long-lasting quality that defines Anjaneya Inks and Coating." },
  { name: "Head of Production", role: "Operations", text: "Leads the production house team, ensuring safe, consistent and efficient manufacturing." },
  { name: "Colour Lab Lead", role: "Quality & R&D", text: "Owns shade matching, batch approval and continuous formulation improvement." },
  { name: "Dispatch & Logistics Lead", role: "Delivery Unit", text: "Coordinates packing, stock and rapid deliveries for bulk and emergency orders." },
];

export const testimonials = [
  {
    id: 1,
    quote: "We switched our carton line to Anjaneya offset inks last year. Colour consistency across repeat orders has been excellent, and their emergency dispatch saved a festival run for us.",
    name: "Sample - Packaging Converter",
    role: "Hyderabad (replace with a real customer)",
  },
  {
    id: 2,
    quote: "Their team matched our brand red on BOPP within a day. Adhesion and heat resistance have been spot on for our flexible packaging.",
    name: "Sample - Flexible Packaging Printer",
    role: "Telangana (replace with a real customer)",
  },
];

export const faqs = [
  { q: "What types of inks and coatings do you manufacture?", a: "We manufacture offset inks, flexographic and gravure inks, specialty inks, overprint varnishes, packaging coatings and protective industrial coatings, along with custom colour-matched formulations." },
  { q: "Do you accept bulk and emergency orders?", a: "Yes. We maintain ready stock of standard shades and bases and operate a dedicated delivery unit, so bulk orders and urgent emergency requirements are dispatched quickly." },
  { q: "Can you match a specific brand or Pantone shade?", a: "Our colour laboratory matches Pantone references, brand standards and physical samples, and records each formulation to guarantee repeatability across future batches." },
  { q: "Which substrates are your inks suitable for?", a: "Paper, board, corrugated, BOPP, PET, polyolefin films, aluminium foil, metal and self-adhesive label stocks, depending on the product series selected." },
  { q: "Where are you located and do you deliver outside Telangana?", a: "Our facility is at Medchal, Telangana. We deliver across Telangana and neighbouring states and can arrange transport for pan-India requirements." },
  { q: "How do I request a sample or quotation?", a: "Use the Reach Us form, email anjaneyainks@gmail.com or call 9490853292 with your substrate, print process and shade details and our team will respond promptly." },
];

export const galleryItems = [
  { id: 1, ...facilityPhotos.mainGate, category: "Facility", caption: "Main Gate" },
  { id: 2, ...facilityPhotos.companyFront, category: "Facility", caption: "Company Front" },
  { id: 3, ...facilityPhotos.companySide, category: "Facility", caption: "Company Side" },
  { id: 4, ...facilityPhotos.productionHouse, category: "Production", caption: "Production House" },
  { id: 5, ...facilityPhotos.productionHouse1, category: "Production", caption: "Dispersers & Mixers" },
  { id: 6, ...facilityPhotos.productionHouse2, category: "Production", caption: "Filling & Let-down Line" },
  { id: 7, ...facilityPhotos.deliveryUnit, category: "Delivery", caption: "Branded Drum - Ready for Delivery" },
  { id: 8, ...facilityPhotos.stock1, category: "Stock", caption: "Stock Yard - Drums" },
  { id: 9, ...facilityPhotos.stock2, category: "Stock", caption: "Ready Stock - Packed Shades" },
];

export const galleryCategories = ["All", "Facility", "Production", "Delivery", "Stock"];

export const footerColumns = [
  {
    heading: "About Us",
    links: [
      { label: "Company Profile", path: "/about" },
      { label: "Our Mission", path: "/about#mission" },
      { label: "Our Team", path: "/about#team" },
      { label: "Gallery", path: "/gallery" },
      { label: "Shade Card", path: "/production#shades" },
    ],
  },
  {
    heading: "Products & Services",
    links: products.map((p) => ({ label: p.title, path: `/production#${p.id}` })),
  },
  {
    heading: "Applications",
    links: applications.map((a) => ({ label: a.title, path: "/production" })),
  },
  {
    heading: "Connect with Us",
    links: [
      { label: "Sales Query", path: "/contact" },
      { label: "Technical Query", path: "/contact" },
      { label: "Locate Our Factory", path: "/contact#locate" },
    ],
  },
];

export const quoteUnits = ["kg", "litres", "drums (200 kg)", "cans (1 kg)", "cans (5 kg)", "packs (20 kg)"];

export const printProcesses = [
  "Sheetfed Offset",
  "Web Offset",
  "Flexographic",
  "Gravure",
  "Screen / Specialty",
  "Industrial Coating",
  "Not sure - please advise",
];

export const substrates = [
  "Paper / Board",
  "Corrugated",
  "BOPP / PET Film",
  "Polyolefin (LDPE / HDPE)",
  "Aluminium Foil",
  "Metal",
  "Self-adhesive Label Stock",
  "Other",
];

// ---------------- Standard shade card ----------------
// Codes are Anjaneya's own (AIC-xxx). Hex values are screen approximations of the physical shade.
export const shadeGroups = [
  {
    id: "process",
    title: "Process Colours",
    note: "Four-colour set for offset, flexo and gravure - balanced for accurate CMYK reproduction.",
    product: "offset-inks",
    shades: [
      { code: "AIC-101", name: "Process Cyan", hex: "#00A3E0" },
      { code: "AIC-102", name: "Process Magenta", hex: "#D62598" },
      { code: "AIC-103", name: "Process Yellow", hex: "#FFDE17" },
      { code: "AIC-104", name: "Process Black", hex: "#1B1B1B" },
      { code: "AIC-105", name: "Dense Black", hex: "#0A0A0A" },
      { code: "AIC-106", name: "Opaque White", hex: "#F7F7F5", light: true },
    ],
  },
  {
    id: "spot",
    title: "Spot & Brand Colours",
    note: "Ready-mixed spot shades for cartons, labels and brand-critical packaging. Custom matches available.",
    product: "custom-colour",
    shades: [
      { code: "AIC-201", name: "Warm Red", hex: "#E63B2E" },
      { code: "AIC-202", name: "Rubine Red", hex: "#C8102E" },
      { code: "AIC-203", name: "Rhodamine Red", hex: "#E10098" },
      { code: "AIC-204", name: "Purple", hex: "#6F2C91" },
      { code: "AIC-205", name: "Reflex Blue", hex: "#001489" },
      { code: "AIC-206", name: "Royal Blue", hex: "#1F4FBF" },
      { code: "AIC-207", name: "Leaf Green", hex: "#00A651" },
      { code: "AIC-208", name: "Lime Green", hex: "#8CC63F" },
      { code: "AIC-209", name: "Orange", hex: "#F26522" },
      { code: "AIC-210", name: "Golden Yellow", hex: "#F9B21A" },
      { code: "AIC-211", name: "Chocolate Brown", hex: "#5C3A21" },
      { code: "AIC-212", name: "Cool Grey", hex: "#8C8F94" },
    ],
  },
  {
    id: "metallic",
    title: "Metallic & Fluorescent",
    note: "High-impact effect shades for premium packaging, labels and promotional print.",
    product: "flexo-gravure-inks",
    shades: [
      { code: "AIC-301", name: "Rich Gold", hex: "linear-gradient(135deg,#E6C25A 0%,#B8892B 55%,#F2D98A 100%)" },
      { code: "AIC-302", name: "Pale Gold", hex: "linear-gradient(135deg,#F0DDA0 0%,#CDAE5E 55%,#F8ECC2 100%)" },
      { code: "AIC-303", name: "Silver", hex: "linear-gradient(135deg,#E8E8E8 0%,#A9ACB0 55%,#F4F4F4 100%)" },
      { code: "AIC-304", name: "Copper", hex: "linear-gradient(135deg,#D9895A 0%,#A45A2A 55%,#E8A67C 100%)" },
      { code: "AIC-305", name: "Fluorescent Pink", hex: "#FF3EB5" },
      { code: "AIC-306", name: "Fluorescent Orange", hex: "#FF6A13" },
      { code: "AIC-307", name: "Fluorescent Green", hex: "#66FF33" },
      { code: "AIC-308", name: "Fluorescent Yellow", hex: "#EEFF00" },
    ],
  },
  {
    id: "coatings",
    title: "Coatings & Varnishes",
    note: "Protective and decorative finishes for printed packaging and industrial surfaces.",
    product: "packaging-coatings",
    shades: [
      { code: "AIC-401", name: "High Gloss OPV", hex: "linear-gradient(135deg,#FFFFFF 0%,#E9EEF2 50%,#FFFFFF 100%)", light: true },
      { code: "AIC-402", name: "Matt OPV", hex: "#E4E4E0", light: true },
      { code: "AIC-403", name: "Soft-touch Coating", hex: "#D8D3CC", light: true },
      { code: "AIC-404", name: "Heat-seal Lacquer", hex: "#F3EBD3", light: true },
      { code: "AIC-405", name: "Anti-corrosive Grey", hex: "#6E7578" },
      { code: "AIC-406", name: "Machinery Green", hex: "#2E7D4F" },
      { code: "AIC-407", name: "Safety Yellow", hex: "#F5C400" },
      { code: "AIC-408", name: "Oxide Red Primer", hex: "#8B3A2F" },
    ],
  },
];
